import fetch,{postFrom} from '../utils/fetch';


export function searchHouseList(params) {
  return fetch({
    method: 'POST',
    url: '/houseSearch/houseList',
    data:params
  })
}
